<template>
  <button
    class="icon-btn"
    :aria-label="ariaLabel"
    type="button"
    @click="$emit('click', $event)"
  >
    <img
      v-show="icon === 'viewable'"
      src="/login/img/icons/viewable.svg"
      class="icon"
      aria-hidden="true"
      alt=""
    >
    <img
      v-show="icon === 'viewableOff'"
      src="/login/img/icons/viewableOff.svg"
      class="icon"
      aria-hidden="true"
      alt=""
    >
  </button>
</template>

<script>
export default {
  name: 'IconButton',
  props: {
    icon: {
      type: String,
      required: true,
    },
    ariaLabel: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.icon-btn {
  align-items: center;
  background: transparent;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  outline: none;
  padding: 10px;
  transition: background 0.15s;
}

.icon-btn:hover,
.icon-btn:focus-visible {
  background: #f0f0f0;
}

.icon {
  display: block;
  height: 20px;
  width: 20px;
}
</style>
